import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeFilterState {
  video: string[];
  banca: number[];
  axis: string[];
  setVideo: (filtros: string[]) => void;
  setBanca: (filtros: number[]) => void;
  setAxis: (filtros: string[]) => void;
  reset: () => void;
}

export const useThemeFilterStore = create<ThemeFilterState>()(
  persist(
    (set) => ({
      video: [],
      banca: [],
      axis: [],
      setVideo: (filtros: string[]) => set({ video: filtros }),
      setBanca: (filtros: number[]) => set({ banca: filtros }),
      setAxis: (filtros: string[]) => set({ axis: filtros }),
      reset: () => set({ 
        video: [],
        banca: [],
        axis: [],
      })
    }),
    { name: 'essay-themes-filter' }
  )
);